/* Kitty Knockout theme script: fighter name, pack picker, cart drawer with upsells, email popup,
   gallery, hotspots, reels and countdowns. Talks to Shopify's AJAX cart API. */
(function () {
  "use strict";

  var KK = window.KK || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  var store = {
    get: function (k, session) { try { return (session ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set: function (k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  };
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  // Formats cents with the shop's own money format ({{amount}}, {{amount_with_comma_separator}}, ...).
  function money(cents) {
    var n = Number(cents) || 0;
    var fmt = String(KK.moneyFormat || "").replace(/<[^>]*>/g, "");
    var tag = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var group = function (dec, thou, point) {
      var parts = (n / 100).toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + point + parts[1] : parts[0];
    };
    if (tag) {
      var v = {
        amount: group(2, ",", "."),
        amount_no_decimals: group(0, ",", "."),
        amount_with_comma_separator: group(2, ".", ","),
        amount_no_decimals_with_comma_separator: group(0, ".", ","),
        amount_with_apostrophe_separator: group(2, "'", "."),
        amount_with_space_separator: group(2, " ", ","),
        amount_no_decimals_with_space_separator: group(0, " ", ",")
      }[tag[1]] || group(2, ",", ".");
      return fmt.replace(tag[0], v);
    }
    try { return new Intl.NumberFormat("en-US", { style: "currency", currency: KK.currency || "USD" }).format(n / 100); }
    catch (e) { return "$" + (n / 100).toFixed(2); }
  }
  function sized(url, w) {
    if (!url) return "";
    if (url.indexOf("cdn.shopify.com") === -1 && url.indexOf("/cdn/shop/") === -1) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }
  var ICON = {
    plus: '<svg class="kk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg class="kk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    wand: '<svg class="kk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20L15 9"/><path d="M15 9c1-4 5-6 6-5.5-.5 1.5-.5 4-2.5 5.8 2 0 3 1.2 3 1.2-2 1.4-5 1.3-6.5-1.5Z"/></svg>',
    gift: '<svg class="kk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-1.5-3-5-3.5-5-1.2C7 7 9.5 7 12 7Zm0 0c1.5-3 5-3.5 5-1.2C17 7 14.5 7 12 7Z"/></svg>',
    sticks: '<svg class="kk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><path d="M7 20L10 4M12 20.5V4M17 20l-3-16"/></svg>'
  };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("[data-toast]");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-on"); }, 2800);
  }
  function copyText(text) {
    var done = function () { toast("Code copied: " + text); };
    var fallback = function () {
      var code = $("[data-popup] code");
      if (!code) return;
      var range = document.createRange();
      range.selectNodeContents(code);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      toast("Code selected. Copy it with your keyboard.");
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, fallback);
    else fallback();
  }

  /* ---------- overlays (drawer, mobile nav) share one scrim ---------- */
  function setBackgroundInert(on) {
    $$(".kk-skip, #MainContent, .kk-header, .kk-announce, .kk-footer, [data-sticky]").forEach(function (el) {
      if (on) el.setAttribute("inert", ""); else el.removeAttribute("inert");
    });
  }
  var Overlay = {
    current: null,
    closers: {},
    open: function (name, closer) {
      this.current = name;
      this.closers[name] = closer;
      var s = $("[data-scrim]");
      if (s) s.classList.add("is-on");
      document.documentElement.style.overflow = "hidden";
      setBackgroundInert(true);
    },
    close: function (name) {
      if (this.current !== name) return;
      this.current = null;
      var s = $("[data-scrim]");
      if (s) s.classList.remove("is-on");
      document.documentElement.style.overflow = "";
      setBackgroundInert(false);
    },
    closeCurrent: function () {
      var fn = this.current && this.closers[this.current];
      if (fn) fn();
    }
  };

  /* ---------- fighter name (the fight card) ---------- */
  var Fighter = {
    value: "",
    clean: function (v) { return String(v || "").replace(/[<>{}]/g, "").replace(/\s+/g, " ").trim().slice(0, 16); },
    set: function (v, from) {
      this.value = this.clean(v);
      store.set("kk-fighter", this.value);
      var val = this.value;
      $$("[data-fighter]").forEach(function (el) { el.textContent = val || el.getAttribute("data-fighter"); });
      $$("[data-fighter-input]").forEach(function (inp) { if (inp !== from && inp.value !== val) inp.value = val; });
      $$("[data-fighter-clear]").forEach(function (b) { b.hidden = !val; });
      $$("[data-fighter-prop]").forEach(function (inp) { inp.value = val; inp.disabled = !val; });
    },
    init: function () {
      $$("[data-fighter-input]").forEach(function (inp) {
        inp.addEventListener("input", function () { Fighter.set(inp.value, inp); });
      });
      $$("[data-fighter-clear]").forEach(function (b) {
        b.addEventListener("click", function () {
          Fighter.set("");
          var i = b.parentNode.querySelector("[data-fighter-input]");
          if (i) i.focus();
        });
      });
      this.set(store.get("kk-fighter") || "");
    }
  };

  /* ---------- announcement bar ---------- */
  function initAnnounce() {
    $$("[data-announce]").forEach(function (bar) {
      var msgs = $$("template[data-announce-item]", bar).map(function (t) { return t.innerHTML; });
      var el = $("[data-announce-msg]", bar);
      if (!el || msgs.length < 2) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var i = 0, paused = false;
      var every = (Number(bar.getAttribute("data-speed")) || 5) * 1000;
      ["mouseenter", "focusin"].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
      ["mouseleave", "focusout"].forEach(function (ev) { bar.addEventListener(ev, function () { paused = false; }); });
      setInterval(function () {
        if (paused) return;
        el.classList.add("is-out");
        setTimeout(function () {
          i = (i + 1) % msgs.length;
          el.innerHTML = msgs[i];
          el.classList.remove("is-out");
        }, 300);
      }, every);
    });
  }

  /* ---------- header + mobile nav ---------- */
  function initHeader() {
    var h = $("[data-header]");
    if (h) {
      var onScroll = function () { h.classList.toggle("is-scrolled", window.scrollY > 6); };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    var nav = $("[data-mnav]");
    if (!nav) return;
    var lastFocus = null;
    function hide() {
      nav.classList.remove("is-on");
      nav.setAttribute("aria-hidden", "true");
      nav.setAttribute("inert", "");
      Overlay.close("mnav");
      $$("[data-mnav-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      if (lastFocus) lastFocus.focus();
    }
    function show() {
      lastFocus = document.activeElement;
      nav.classList.add("is-on");
      nav.setAttribute("aria-hidden", "false");
      nav.removeAttribute("inert");
      Overlay.open("mnav", hide);
      $$("[data-mnav-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      var f = $("[data-mnav-close]", nav);
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    $$("[data-mnav-open]").forEach(function (b) { b.addEventListener("click", show); });
    $$("[data-mnav-close]").forEach(function (b) { b.addEventListener("click", hide); });
    $$("a", nav).forEach(function (a) { a.addEventListener("click", function () { if (a.getAttribute("href").charAt(0) === "#" || a.hash) hide(); }); });
  }

  /* ---------- dates: delivery estimate + countdowns ---------- */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function initEta() {
    var s = KK.ship || {};
    var p = s.processing || [1, 3], t = s.transit || [4, 7];
    var now = new Date();
    var a = addBusinessDays(now, p[0] + t[0]);
    var b = addBusinessDays(now, p[1] + t[1]);
    var f = function (d) { return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); };
    $$("[data-eta]").forEach(function (el) { el.textContent = f(a) + " – " + f(b); });
    var shipA = addBusinessDays(now, p[0]), shipB = addBusinessDays(now, p[1]);
    $$("[data-tl]").forEach(function (el) {
      var k = el.getAttribute("data-tl");
      el.textContent = k === "ordered" ? f(now) : k === "shipped" ? f(shipA) + " – " + f(shipB) : f(a) + " – " + f(b);
    });
  }

  /* ---------- before / after slider ---------- */
  function initVersus() {
    $$("[data-versus]").forEach(function (box) {
      var range = $("[data-versus-range]", box);
      if (!range) return;
      var set = function () { box.style.setProperty("--pos", range.value + "%"); };
      range.addEventListener("input", set);
      set();
    });
  }

  /* ---------- tabs (signature moves) and FAQ filters ---------- */
  function initTabs() {
    $$("[data-tabs]").forEach(function (root) {
      var tabs = $$("[data-tab]", root), panels = $$("[data-panel]", root), media = $$("[data-panel-media]", root);
      function show(i) {
        tabs.forEach(function (t, j) { t.setAttribute("aria-selected", i === j ? "true" : "false"); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        media.forEach(function (m, j) { m.hidden = i !== j; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { show(i); });
        t.addEventListener("keydown", function (e) {
          if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
          e.preventDefault();
          var n = (i + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
          show(n);
          tabs[n].focus();
        });
      });
      if (tabs.length) show(0);
    });
    $$("[data-faq-filter]").forEach(function (root) {
      var btns = $$("[data-faq-cat]", root), items = $$("[data-cat]", root);
      // a topic with no questions is never offered, so a filter can't empty the list
      btns.forEach(function (b) {
        var c = b.getAttribute("data-faq-cat");
        if (c !== "all" && !items.some(function (it) { return it.getAttribute("data-cat") === c; })) b.hidden = true;
      });
      var row = btns.length ? btns[0].parentElement : null;
      if (row && btns.filter(function (b) { return !b.hidden; }).length < 3) row.hidden = true;
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          var c = b.getAttribute("data-faq-cat");
          btns.forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          items.forEach(function (it) { it.hidden = c !== "all" && it.getAttribute("data-cat") !== c; });
        });
      });
    });
  }
  function initCountdowns() {
    var els = $$("[data-countdown]");
    if (!els.length) return;
    function pad(v) { return v < 10 ? "0" + v : String(v); }
    function tick() {
      els.forEach(function (el) {
        var end = new Date(el.getAttribute("data-countdown")).getTime();
        var ms = end - Date.now();
        if (!(ms > 0)) {
          var sel = el.getAttribute("data-countdown-hide");
          var target = sel ? el.closest(sel) : el;
          if (target) target.hidden = true;
          return;
        }
        var d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4), s = Math.floor((ms % 6e4) / 1e3);
        var far = d >= 14;
        $$("[data-cd-far]", el).forEach(function (x) { x.hidden = !far; });
        $$("[data-cd-near]", el).forEach(function (x) { x.hidden = far; });
        var put = function (k, v) { var x = $('[data-cd="' + k + '"]', el); if (x) x.textContent = v; };
        put("d", pad(d)); put("h", pad(h)); put("m", pad(m)); put("s", pad(s));
        put("inline", d + "d " + h + "h " + m + "m");
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- hotspots ---------- */
  function initSpots() {
    $$("[data-spots]").forEach(function (root) {
      var spots = $$("[data-spot]", root), feats = $$("[data-feat]", root);
      if (!spots.length) return;
      var timer = null;
      function activate(i) {
        spots.forEach(function (s, j) { s.classList.toggle("is-active", i === j); s.setAttribute("aria-pressed", i === j ? "true" : "false"); });
        feats.forEach(function (f, j) { f.classList.toggle("is-active", i === j); f.setAttribute("aria-pressed", i === j ? "true" : "false"); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      [spots, feats].forEach(function (list) {
        list.forEach(function (el, i) {
          el.addEventListener("click", function () { stop(); activate(i); });
          el.addEventListener("mouseenter", function () { stop(); activate(i); });
          el.addEventListener("focus", function () { stop(); activate(i); });
        });
      });
      activate(0);
      if (!reduced && spots.length > 1) {
        var i = 0;
        timer = setInterval(function () { i = (i + 1) % spots.length; activate(i); }, 3400);
        root.addEventListener("touchstart", stop, { passive: true });
      }
    });
  }

  /* ---------- reels ---------- */
  function initReels() {
    $$("[data-reel]").forEach(function (root) {
      var track = $("[data-reel-track]", root);
      if (!track) return;
      var prev = $("[data-reel-prev]", root), next = $("[data-reel-next]", root);
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; }
      function update() {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: reduced ? "auto" : "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: reduced ? "auto" : "smooth" }); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- autoplay videos only while visible ---------- */
  function initVideos() {
    var vids = $$("video[autoplay], video[data-autoplay]");
    if (!vids.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute("playsinline", ""); io.observe(v); });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    $$("[data-gallery]").forEach(function (g) {
      var track = $("[data-gallery-track]", g);
      if (!track) return;
      var slides = $$("[data-slide]", track), thumbs = $$("[data-thumb]", g), dots = $$("[data-dot]", g);
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? "auto" : "smooth" });
      }
      function mark() {
        var i = current();
        thumbs.forEach(function (t, j) { t.classList.toggle("is-active", i === j); t.setAttribute("aria-current", i === j ? "true" : "false"); });
        dots.forEach(function (d, j) { d.classList.toggle("is-active", i === j); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { go(i); }); });
      dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });
      var prev = $("[data-gallery-prev]", g), next = $("[data-gallery-next]", g);
      if (prev) prev.addEventListener("click", function () { go(current() - 1); });
      if (next) next.addEventListener("click", function () { go(current() + 1); });
      var raf;
      track.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); go(current() + 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); go(current() - 1); }
      });
      mark();
    });
  }

  /* ---------- preview cart (only used by the static design preview, never on Shopify) ---------- */
  var Preview = {
    items: [],
    load: function () { try { this.items = JSON.parse(sessionStorage.getItem("kk-preview-cart") || "[]"); } catch (e) { this.items = []; } },
    save: function () { try { sessionStorage.setItem("kk-preview-cart", JSON.stringify(this.items)); } catch (e) {} },
    find: function (id) { return (KK.catalog || []).filter(function (v) { return v.id === id; })[0]; },
    snapshot: function () {
      var items = this.items.map(function (it) {
        var line = it.price * it.quantity;
        var free = it.properties && it.properties._gift ? Math.min(line, it.price) : 0;
        return Object.assign({}, it, { original_line_price: line, final_line_price: line - free, line_price: line - free });
      });
      var total = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var orig = items.reduce(function (s, i) { return s + i.original_line_price; }, 0);
      return { items: items, item_count: items.reduce(function (s, i) { return s + i.quantity; }, 0), total_price: total, original_total_price: orig, total_discount: orig - total, currency: "USD" };
    },
    api: function (url, body) {
      var self = this;
      return new Promise(function (resolve) {
        setTimeout(function () {
          if (url === KK.routes.cartAdd) {
            (body.items || []).forEach(function (req) {
              var v = self.find(Number(req.id));
              if (!v) return;
              var props = req.properties || {};
              var key = v.id + ":" + JSON.stringify(props);
              var ex = self.items.filter(function (i) { return i.key === key; })[0];
              if (ex) ex.quantity += req.quantity || 1;
              else self.items.push({ key: key, id: v.id, variant_id: v.id, product_id: v.product_id, product_title: v.product_title, variant_title: v.variant_title, product_has_only_default_variant: !v.variant_title, price: v.price, quantity: req.quantity || 1, properties: props, image: v.image });
            });
            self.save();
            resolve({ items: [] });
          } else if (url === KK.routes.cartChange) {
            var it = self.items.filter(function (i) { return i.key === body.id; })[0];
            if (it) {
              it.quantity = body.quantity;
              if (it.quantity <= 0) self.items = self.items.filter(function (i) { return i !== it; });
            }
            self.save();
            resolve(self.snapshot());
          } else resolve(self.snapshot());
        }, 180);
      });
    }
  };

  // "Championship + The Contender", repeats grouped: "2× Championship"
  function packLabel(packs) {
    var seen = [], count = {};
    packs.forEach(function (v) { if (!count[v.id]) { count[v.id] = 0; seen.push(v); } count[v.id]++; });
    return seen.map(function (v) { return (count[v.id] > 1 ? count[v.id] + "× " : "") + v.name; }).join(" + ");
  }

  /* ---------- cart ---------- */
  var Cart = {
    state: null,
    onToggle: null,
    lastFocus: null,
    queue: Promise.resolve(),
    clearing: false,
    // Runs cart changes one at a time, so two clicks can never race each other (or add a gift twice).
    run: function (job) {
      var self = this;
      var p = this.queue.then(function () { self.busy(true); return job(); });
      this.queue = p.catch(function () {}).then(function () { self.busy(false); });
      return p;
    },
    api: function (url, body) {
      if (KK.preview) return Preview.api(url, body);
      var opts = body
        ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
        : { headers: { Accept: "application/json" } };
      return fetch(url, opts).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || "Something went wrong. Try again.");
          return j;
        });
      });
    },
    refresh: function () {
      var self = this;
      return this.api(KK.routes.cartJs).then(function (c) { self.state = c; self.render(); return c; });
    },
    add: function (items) { return this.api(KK.routes.cartAdd, { items: items }); },
    setQty: function (key, qty) {
      var self = this;
      return this.run(function () {
        return self.api(KK.routes.cartChange, { id: key, quantity: qty })
          .then(function () { return self.reconcileGift(); })
          .then(function () { return self.refresh(); })
          .catch(function (e) { toast(e.message); return self.refresh(); });
      });
    },
    variantOf: function (id) {
      if (!KK.main) return null;
      return KK.main.variants.filter(function (v) { return v.id === Number(id); })[0] || null;
    },
    addVariant: function (id, props, btn) {
      var self = this;
      if (btn) btn.classList.add("is-loading");
      return this.run(function () {
        return self.add([{ id: Number(id), quantity: 1, properties: props || {} }])
          .then(function () { return self.reconcileGift(); })
          .then(function () { return self.refresh(); })
          .then(function () {
            bump();
            if (KK.cartType === "page") { window.location.href = KK.routes.cart; return; }
            self.open();
          })
          .catch(function (e) { toast(e.message || "Couldn't add that to your cart."); });
      }).finally(function () { if (btn) btn.classList.remove("is-loading"); });
    },
    addFromForm: function (form, btn) {
      var fd = new FormData(form);
      var id = fd.get("id");
      if (!id) { toast("Pick a pack first"); return; }
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim()) props[m[1]] = String(v).trim();
      });
      this.addVariant(id, props, btn);
    },
    declined: function () { try { return JSON.parse(store.get("kk-gift-declined", true) || "[]"); } catch (e) { return []; } },
    decline: function (variant) { var d = this.declined(); if (d.indexOf(variant) === -1) d.push(variant); store.set("kk-gift-declined", JSON.stringify(d), true); },
    undecline: function (variant) { store.set("kk-gift-declined", JSON.stringify(this.declined().filter(function (x) { return x !== variant; })), true); },
    // Adds each free gift when a big enough pack is in the cart, and removes it when there isn't one.
    // Never throws: a gift that can't be added must not make the main add-to-cart look failed.
    // Resolves to true when it changed the cart.
    reconcileGift: function () {
      var gifts = (KK.gifts || []).filter(function (g) { return g.variant; });
      if (!gifts.length || !KK.main) return Promise.resolve(false);
      var self = this, declined = this.declined();
      return this.api(KK.routes.cartJs).then(function (c) {
        var maxUnits = c.items.reduce(function (m, it) { var v = self.variantOf(it.variant_id); return v ? Math.max(m, v.units) : m; }, 0);
        var adds = [], chain = Promise.resolve(), changed = false;
        gifts.forEach(function (g) {
          var line = c.items.filter(function (it) { return it.variant_id === g.variant && it.properties && it.properties._gift; })[0];
          var qualifies = maxUnits >= g.units;
          // a gift removed earlier comes back with the next qualifying pack, not never
          if (!qualifies && declined.indexOf(g.variant) !== -1) self.undecline(g.variant);
          if (qualifies && !line && declined.indexOf(g.variant) === -1) { adds.push({ id: g.variant, quantity: 1, properties: { _gift: "Free gift with your pack" } }); changed = true; }
          else if (!qualifies && line) { changed = true; chain = chain.then(function () { return self.api(KK.routes.cartChange, { id: line.key, quantity: 0 }); }); }
          else if (line && line.quantity > 1) { changed = true; chain = chain.then(function () { return self.api(KK.routes.cartChange, { id: line.key, quantity: 1 }); }); }
        });
        adds.forEach(function (a) { chain = chain.then(function () { return self.add([a]).catch(function () { self.soldOut = (self.soldOut || []).concat(a.id); }); }); });
        return chain.then(function () { return changed; });
      }).catch(function () { return false; });
    },
    keepProps: function (line) {
      var keep = {};
      Object.keys((line && line.properties) || {}).forEach(function (k) { if (line.properties[k] && k.charAt(0) !== "_") keep[k] = line.properties[k]; });
      return keep;
    },
    upgrade: function (key, toVariant, btn) {
      var self = this;
      if (btn) btn.disabled = true;
      // add the bigger pack first; only then take the smaller one out, so a failed add never loses a Roo.
      // The line is looked up again inside the job, so a second press (Enter key repeat) can't add a second pack.
      return this.run(function () {
        return self.api(KK.routes.cartJs).then(function (c) {
          var line = c.items.filter(function (it) { return it.key === key; })[0];
          if (!line) return self.refresh();
          return self.add([{ id: toVariant.id, quantity: 1, properties: self.keepProps(line) }])
            .then(function () { return self.api(KK.routes.cartChange, { id: line.key, quantity: line.quantity - 1 }); })
            .then(function () { return self.reconcileGift(); })
            .then(function () { return self.refresh(); })
            .then(function () { toast("Upgraded to " + toVariant.name); });
        }).catch(function (e) { toast(e.message); return self.refresh(); });
      });
    },
    // Several single packs that add up to a bigger pack: swap them for that pack (same Roos, lower price).
    swap: function (packs, units, btn) {
      var self = this;
      if (btn) btn.setAttribute("aria-disabled", "true");
      return this.run(function () {
        return self.api(KK.routes.cartJs).then(function (c) {
          var lines = c.items.filter(function (it) { return self.variantOf(it.variant_id); });
          var have = lines.reduce(function (s, it) { return s + self.variantOf(it.variant_id).units * it.quantity; }, 0);
          if (have !== units) return self.refresh();
          // keep every fight-card name the shopper typed
          var names = [];
          lines.forEach(function (it) { var n = it.properties && it.properties.Fighter; if (n && names.indexOf(n) === -1) names.push(n); });
          var props = names.length ? { Fighter: names.join(" & ").slice(0, 60) } : {};
          return self.add(packs.map(function (v) { return { id: v.id, quantity: 1, properties: props }; }))
            .then(function () { return self.api(KK.routes.cartJs); })
            .then(function (c2) {
              // Shopify merges a new pack into an old line with the same variant and properties,
              // so take away only each old line's original quantity, never the packs just added
              return lines.reduce(function (p, it) {
                var now = c2.items.filter(function (x) { return x.key === it.key; })[0];
                var q = now ? Math.max(0, now.quantity - it.quantity) : 0;
                return p.then(function () { return self.api(KK.routes.cartChange, { id: it.key, quantity: q }); });
              }, Promise.resolve());
            })
            .then(function () { return self.reconcileGift(); })
            .then(function () { return self.refresh(); })
            .then(function () { toast("Switched to " + packLabel(packs)); });
        }).catch(function (e) { toast(e.message); return self.refresh(); });
      });
    },
    restoreGift: function (variant) {
      var self = this;
      this.undecline(variant);
      return this.run(function () {
        return self.reconcileGift().then(function () { return self.refresh(); }).catch(function () { return self.refresh(); }).then(function (c) {
          var back = c && c.items && c.items.some(function (it) { return it.variant_id === variant && it.properties && it.properties._gift; });
          if (!back) { self.decline(variant); self.soldOut = (self.soldOut || []).concat(variant); self.render(); toast("Sorry, that gift is out of stock right now."); }
        });
      });
    },
    toggleProtection: function (on) {
      var p = KK.protection, self = this;
      if (!p) return;
      return this.run(function () {
        var line = (self.state && self.state.items || []).filter(function (it) { return it.variant_id === p.variant; })[0];
        var job = on && !line
          ? self.add([{ id: p.variant, quantity: 1 }])
          : (!on && line ? self.api(KK.routes.cartChange, { id: line.key, quantity: 0 }) : Promise.resolve());
        return job.then(function () { return self.refresh(); }).catch(function (e) { toast(e.message); return self.refresh(); });
      });
    },
    addAddon: function (variant, btn) {
      var self = this;
      if (btn) btn.disabled = true;
      return this.run(function () {
        return self.add([{ id: Number(variant), quantity: 1 }])
          .then(function () { return self.refresh(); })
          .then(function () { toast("Added to cart"); bump(); })
          .catch(function (er) { toast(er.message); if (btn) btn.disabled = false; });
      });
    },
    busy: function (on) { var d = $("[data-drawer]"); if (d) d.classList.toggle("is-busy", !!on); },
    isOpen: function () { var d = $("[data-drawer]"); return !!(d && d.classList.contains("is-on")); },
    open: function () {
      var d = $("[data-drawer]");
      if (!d) { window.location.href = KK.routes.cart; return; }
      this.lastFocus = document.activeElement;
      d.classList.add("is-on");
      d.setAttribute("aria-hidden", "false");
      d.removeAttribute("inert");
      Overlay.open("drawer", function () { Cart.close(); });
      setTimeout(function () { var x = $("[data-drawer-close]", d); if (x) x.focus(); }, 80);
      if (this.onToggle) this.onToggle();
    },
    close: function () {
      var d = $("[data-drawer]");
      if (!d) return;
      d.classList.remove("is-on");
      d.setAttribute("aria-hidden", "true");
      d.setAttribute("inert", "");
      Overlay.close("drawer");
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      if (this.onToggle) this.onToggle();
    },

    render: function () {
      var c = this.state;
      if (!c) return;
      $$("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; el.setAttribute("data-count", c.item_count); });
      var d = $("[data-drawer]");
      if (!d) return;
      var body = $("[data-drawer-body]", d), foot = $("[data-drawer-foot]", d);
      // the tier card scrolls with the lines; keep one reference, since re-rendering the body detaches it
      var tier = this.tierEl = this.tierEl || $("[data-tier]", d);
      var express = this.expressEl = this.expressEl || $("[data-drawer-express]", d);
      var countEl = $("[data-drawer-count]", d);
      if (countEl) countEl.textContent = c.item_count ? c.item_count + (c.item_count === 1 ? " item" : " items") : "";

      var self = this;
      var protect = KK.protection;
      var gifts = KK.gifts || [];
      // the body is rebuilt below; remember which control had focus so keyboard users stay in place
      var ae = document.activeElement, refocus = null;
      if (ae && body.contains(ae) && ae !== body) refocus = { qty: ae.getAttribute("data-qty"), label: ae.getAttribute("aria-label"), id: ae.id };
      // a pressed button that got disabled loses focus to <body>; bring it back into the dialog
      else if (this.isOpen() && (!ae || ae === document.body)) refocus = {};
      var protectLine = protect ? c.items.filter(function (it) { return it.variant_id === protect.variant; })[0] : null;
      var rank = function (it) { return self.variantOf(it.variant_id) ? 0 : (it.properties && it.properties._gift ? 2 : 1); };
      // packs first, then add-ons, then free gifts (sort is stable)
      var items = c.items.filter(function (it) { return !protect || it.variant_id !== protect.variant; })
        .sort(function (a, b) { return rank(a) - rank(b); });

      if (!items.length) {
        var tpl = $("template[data-empty-cart]");
        body.innerHTML = tpl ? tpl.innerHTML : "";
        foot.innerHTML = "";
        foot.hidden = true;
        if (express) express.hidden = true;
        if (tier) tier.hidden = true;
        // protection on its own makes no sense; clear it once (guarded so a failing request can't loop)
        if (protectLine && !this.clearing) {
          this.clearing = true;
          this.setQty(protectLine.key, 0).finally(function () { self.clearing = false; });
        }
        return;
      }
      foot.hidden = false;

      /* tier progress */
      var mainLines = items.filter(function (it) { return self.variantOf(it.variant_id); });
      var maxUnits = mainLines.reduce(function (m, it) { return Math.max(m, self.variantOf(it.variant_id).units); }, 0);
      var V = KK.main ? KK.main.variants.filter(function (v) { return v.available !== false; }).sort(function (a, b) { return a.units - b.units; }) : [];
      var nextV = V.filter(function (v) { return v.units > maxUnits; })[0];
      var curV = V.filter(function (v) { return v.units === maxUnits; })[0];
      // several singles (or a pack plus a single) that equal a bigger pack: offer the cheaper pack instead
      var totalUnits = mainLines.reduce(function (s, it) { return s + self.variantOf(it.variant_id).units * it.quantity; }, 0);
      var paid = mainLines.reduce(function (s, it) { return s + self.variantOf(it.variant_id).price * it.quantity; }, 0);
      // cheapest mix of packs that holds the same number of Roos (small unbounded knapsack)
      var best = [{ cost: 0, packs: [] }];
      for (var u = 1; u <= totalUnits && u <= 60; u++) {
        best[u] = null;
        V.forEach(function (v) { var prev = u >= v.units ? best[u - v.units] : null; if (prev && (!best[u] || prev.cost + v.price < best[u].cost)) best[u] = { cost: prev.cost + v.price, packs: prev.packs.concat(v) }; });
      }
      var plan = best[totalUnits];
      if (plan) plan = { cost: plan.cost, packs: plan.packs.slice().sort(function (a, b) { return b.units - a.units; }) };
      var swapTo = plan && totalUnits > maxUnits && plan.cost < paid ? plan : null;
      var planName = swapTo ? (swapTo.packs.length === 1 ? "the " + swapTo.packs[0].name : packLabel(swapTo.packs)) : "";
      var planMax = swapTo ? swapTo.packs.reduce(function (m, v) { return Math.max(m, v.units); }, 0) : 0;
      var single = !swapTo && totalUnits === maxUnits; // one pack, quantity 1: the only case an "add one more Roo" upgrade makes sense
      var inCartGift = function (g) { return c.items.some(function (it) { return it.variant_id === g.variant && it.properties && it.properties._gift; }); };
      if (tier) {
        tier.hidden = !maxUnits || !V.length;
        if (maxUnits && V.length) {
          var msg;
          var newGifts = nextV ? gifts.filter(function (g) { return g.units > maxUnits && g.units <= nextV.units; }) : [];
          var haveGifts = gifts.filter(function (g) { return g.units <= maxUnits && inCartGift(g); });
          var names = function (list) { return list.map(function (g) { return "<strong>" + esc(g.label) + "</strong>"; }).join(" and "); };
          if (swapTo) {
            var swapGifts = gifts.filter(function (g) { return g.units <= planMax && g.units > maxUnits; });
            msg = "You have " + totalUnits + " Roos. As " + esc(planName) + " they cost <strong>" + money(swapTo.cost) + "</strong> instead of " + money(paid) + (swapGifts.length ? ", with " + names(swapGifts) + " free." : ".");
          } else if (!single) {
            msg = "<strong>" + totalUnits + " Roos</strong> in your cart" + (haveGifts.length ? ", plus " + names(haveGifts) + " free." : ".");
          } else if (nextV && curV) {
            msg = "Add another Roo for <strong>" + money(nextV.price - curV.price) + "</strong> to upgrade to the " + esc(nextV.name) + (newGifts.length ? " and get " + names(newGifts) + " free." : ".");
          } else {
            msg = "<strong>" + esc(curV ? curV.name : "Best price") + "</strong>: the lowest price per Roo" + (haveGifts.length ? ", plus " + names(haveGifts) + " free." : ".");
          }
          $("[data-tier-msg]", tier).innerHTML = msg;
          // one column per pack; the fill ends exactly under the label of the pack reached
          var reached = V.filter(function (v) { return v.units <= Math.max(maxUnits, swapTo ? planMax : 0); }).length;
          $("[data-tier-fill]", tier).style.width = Math.round((reached / V.length) * 100) + "%";
          var steps = $("[data-tier-steps]", tier);
          steps.style.gridTemplateColumns = "repeat(" + V.length + ",minmax(0,1fr))";
          steps.innerHTML = V.map(function (v) {
            var cls = v.units <= maxUnits ? ' class="is-done"' : (swapTo && v.units <= planMax ? ' class="is-plan"' : "");
            return "<span" + cls + ">" + v.units + (v.units === 1 ? " Roo" : " Roos") + "</span>";
          }).join("");
        }
      }

      /* lines */
      var html = items.map(function (it) {
        var props = it.properties || {};
        var isGift = !!props._gift;
        var meta = [];
        var v = self.variantOf(it.variant_id);
        if (v) meta.push(esc(v.name));
        else if (!it.product_has_only_default_variant && it.variant_title) meta.push(esc(it.variant_title));
        if (props.Fighter) meta.push("Fight card: " + esc(props.Fighter) + " vs. The Roo");
        var src = sized(it.featured_image && it.featured_image.url ? it.featured_image.url : it.image, 200);
        var addon = (KK.addons || []).filter(function (a) { return a.variant === it.variant_id; })[0];
        // no photo yet: the add-on's icon, a gift icon for gifts, otherwise the Roo thumbnail
        var icon = addon && ICON[addon.icon] ? ICON[addon.icon] : (isGift ? ICON.gift : "");
        var thumb = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">'
          : (icon ? '<span class="kk-line__icon">' + icon + "</span>" : '<img src="' + esc(KK.fallbackImage) + '" alt="" loading="lazy">');
        var priceHTML = it.final_line_price < it.original_line_price
          ? "<s>" + money(it.original_line_price) + "</s>" + (it.final_line_price === 0 ? "Free" : money(it.final_line_price))
          : (it.final_line_price === 0 ? "Free" : money(it.final_line_price));
        var ctrl = isGift
          ? '<div class="kk-line__ctrl"><button class="kk-remove" type="button" data-qty="' + esc(it.key) + '" data-to="0" data-gift-remove="' + it.variant_id + '" aria-label="Remove ' + esc(it.product_title) + '">Remove</button></div>'
          : '<div class="kk-line__ctrl"><div class="kk-qty"><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="Remove one ' + esc(it.product_title) + '">' + ICON.minus + "</button><span>" + it.quantity + '</span><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="Add one ' + esc(it.product_title) + '">' + ICON.plus + '</button></div><button class="kk-remove" type="button" data-qty="' + esc(it.key) + '" data-to="0" aria-label="Remove ' + esc(it.product_title) + '">Remove</button></div>';
        return '<div class="kk-line"><div class="kk-line__img">' + thumb + '</div><div><div class="kk-line__title">' + esc(it.product_title) + "</div>" +
          (meta.length ? '<div class="kk-line__meta">' + meta.join(" · ") + "</div>" : "") +
          (isGift ? '<div class="kk-line__gift">' + esc(props._gift) + "</div>" : "") + ctrl +
          '</div><div class="kk-line__price">' + priceHTML + "</div></div>";
      }).join("");

      /* swap card (several singles → one pack), otherwise the upgrade card */
      if (swapTo) {
        var swapGifts2 = gifts.filter(function (g) { return g.units <= planMax && g.units > maxUnits; });
        html += '<div class="kk-upsell"><div><span class="kk-upsell__title">Switch to ' + esc(packLabel(swapTo.packs)) + "</span><p>Same " + totalUnits + " Roos for " + money(swapTo.cost) + ", save " + money(paid - swapTo.cost) +
          (swapGifts2.length ? ", plus " + swapGifts2.map(function (g) { return esc(g.label); }).join(" and ") + " free" : "") + ".</p></div>" +
          '<button class="kk-btn kk-btn--light" type="button" data-swap-to="' + swapTo.packs.map(function (v) { return v.id; }).join(",") + '" data-swap-units="' + totalUnits + '">Switch</button></div>';
      } else if (single && nextV && curV) {
        var upLine = mainLines.filter(function (it) { return self.variantOf(it.variant_id).units === maxUnits; })[0];
        if (upLine) {
          var upGifts = gifts.filter(function (g) { return g.units > maxUnits && g.units <= nextV.units; });
          html += '<div class="kk-upsell"><div><span class="kk-upsell__title">Go ' + esc(nextV.name) + "</span><p>" + nextV.units + " Roos for " + money(nextV.price) +
            (upGifts.length ? ", plus " + upGifts.map(function (g) { return esc(g.label); }).join(" and ") + " free" : "") + ".</p></div>" +
            '<button class="kk-btn kk-btn--light" type="button" data-upgrade="' + esc(upLine.key) + '" data-upgrade-to="' + nextV.id + '" aria-label="Upgrade to the ' + esc(nextV.name) + " for " + money(nextV.price - curV.price) + ' more">+' + money(nextV.price - curV.price) + "</button></div>";
        }
      }

      /* add-ons */
      var inCart = function (variant) { return c.items.some(function (it) { return it.variant_id === variant; }); };
      var giftVariants = gifts.filter(function (g) { return maxUnits >= g.units; }).map(function (g) { return g.variant; });
      var offers = (KK.addons || []).filter(function (a) { return !inCart(a.variant) && giftVariants.indexOf(a.variant) === -1; });
      // a free gift the shopper removed can be added back with one tap
      var declinedNow = this.declined();
      var restorable = gifts.filter(function (g) { return maxUnits >= g.units && !inCartGift(g) && declinedNow.indexOf(g.variant) !== -1 && (self.soldOut || []).indexOf(g.variant) === -1; });
      if (offers.length || restorable.length) {
        html += '<div class="kk-addons"><p class="kk-label">Add-ons</p>' + restorable.map(function (g) {
          var a = (KK.addons || []).filter(function (x) { return x.variant === g.variant; })[0];
          var thumb = g.image ? '<img src="' + esc(g.image) + '" alt="">' : (a && ICON[a.icon] ? ICON[a.icon] : ICON.gift);
          return '<div class="kk-addon"><div class="kk-addon__img">' + thumb + "</div><div><b>" + esc(g.label) + "</b><span>Free with your pack</span></div>" +
            '<button type="button" data-gift-restore="' + g.variant + '">Add free</button></div>';
        }).join("") + offers.map(function (a) {
          var thumb = a.image ? '<img src="' + esc(a.image) + '" alt="">' : (ICON[a.icon] || "");
          return '<div class="kk-addon"><div class="kk-addon__img">' + thumb + "</div><div><b>" + esc(a.title) + "</b><span>" + esc(a.text || "") +
            '</span></div><button type="button" data-addon="' + a.variant + '" aria-label="Add ' + esc(a.title) + " for " + money(a.price) + '">+ ' + money(a.price) + "</button></div>";
        }).join("") + "</div>";
      }

      /* package protection (opt-in) */
      if (protect) {
        html += '<label class="kk-protect" for="kk-protect"><span class="kk-protect__txt"><b>' + esc(protect.title || "Package protection") + " · " + money(protect.price) + "</b>" + esc(protect.text || "") +
          '</span><span class="kk-switch"><input type="checkbox" id="kk-protect" data-protect' + (protectLine ? " checked" : "") + '><span></span></span></label>';
      }
      body.innerHTML = html;
      if (tier) body.insertBefore(tier, body.firstChild);
      if (refocus && this.isOpen()) {
        var target = $$("button, input", body).filter(function (el) {
          if (refocus.qty) return el.getAttribute("data-qty") === refocus.qty && el.getAttribute("aria-label") === refocus.label;
          if (refocus.id) return el.id === refocus.id;
          return false;
        })[0];
        if (!target || target.disabled) { var t = $("#kk-drawer-title", d); if (t) { t.setAttribute("tabindex", "-1"); target = t; } }
        if (target) target.focus({ preventScroll: true });
      }

      /* footer: subtotal, discounts, shipping, total; pack savings are real (measured against buying singles) */
      var single = V.length ? V[0].price / Math.max(1, V[0].units) : 0;
      var packSave = mainLines.reduce(function (s, it) { var v = self.variantOf(it.variant_id); return s + Math.max(0, single * v.units - v.price) * it.quantity; }, 0);
      var subtotal = c.original_total_price || c.total_price || 0;
      var discount = Math.max(0, subtotal - (c.total_price || 0));
      var giftOff = items.reduce(function (s, it) { return s + (it.properties && it.properties._gift ? Math.max(0, (it.original_line_price || 0) - (it.final_line_price || 0)) : 0); }, 0);
      giftOff = Math.min(giftOff, discount);
      var saved = packSave + discount;
      foot.innerHTML =
        '<div class="kk-sums">' +
        '<div class="kk-sum"><span>Subtotal</span><span>' + money(subtotal - (protectLine ? protectLine.final_line_price : 0)) + "</span></div>" +
        (protectLine ? '<div class="kk-sum"><span>' + esc(protect.title || "Package protection") + "</span><span>" + money(protectLine.final_line_price) + "</span></div>" : "") +
        (giftOff > 0 ? '<div class="kk-sum kk-sum--save"><span>Free gifts</span><span>−' + money(giftOff) + "</span></div>" : "") +
        (discount - giftOff > 0 ? '<div class="kk-sum kk-sum--save"><span>Discounts</span><span>−' + money(discount - giftOff) + "</span></div>" : "") +
        '<div class="kk-sum"><span>Shipping</span><span>' + esc(KK.text && KK.text.freeShipping ? "Free" : "At checkout") + "</span></div>" +
        '<div class="kk-sum kk-sum--total"><span>Total' + (saved > 0 ? '<small class="kk-sum__saved">You save ' + money(saved) + "</small>" : "") + "</span><span>" + money(c.total_price) + "</span></div>" +
        "</div>" +
        '<a class="kk-btn kk-btn--block kk-btn--lg" href="/checkout" data-checkout>Checkout<span class="kk-btn__sep" aria-hidden="true"></span>' + money(c.total_price) + "</a>" +
        (KK.text && KK.text.cartNote ? '<p class="kk-fine">' + esc(KK.text.cartNote) + "</p>" : "");
      if (express) { express.hidden = false; foot.insertBefore(express, foot.lastElementChild && foot.lastElementChild.classList.contains("kk-fine") ? foot.lastElementChild : null); }
    },

    init: function () {
      var self = this;
      if (KK.preview) Preview.load();
      $$("[data-cart-open]").forEach(function (a) {
        a.addEventListener("click", function (e) {
          if (KK.cartType === "page") return;
          e.preventDefault();
          self.refresh().then(function () { self.open(); });
        });
      });
      var d = $("[data-drawer]");
      if (d) {
        $$("[data-drawer-close]", d).forEach(function (b) { b.addEventListener("click", function () { self.close(); }); });
        d.addEventListener("click", function (e) {
          var q = e.target.closest("[data-qty]");
          if (q) {
            if (q.hasAttribute("data-gift-remove")) self.decline(Number(q.getAttribute("data-gift-remove")));
            self.setQty(q.getAttribute("data-qty"), Number(q.getAttribute("data-to")));
            return;
          }
          var up = e.target.closest("[data-upgrade]");
          if (up) {
            var to = self.variantOf(up.getAttribute("data-upgrade-to"));
            if (to && !up.disabled) self.upgrade(up.getAttribute("data-upgrade"), to, up);
            return;
          }
          var sw = e.target.closest("[data-swap-to]");
          if (sw) {
            var packs = sw.getAttribute("data-swap-to").split(",").map(function (id) { return self.variantOf(id); }).filter(Boolean);
            if (packs.length && sw.getAttribute("aria-disabled") !== "true") self.swap(packs, Number(sw.getAttribute("data-swap-units")), sw);
            return;
          }
          var gr = e.target.closest("[data-gift-restore]");
          if (gr) { if (gr.getAttribute("aria-disabled") !== "true") { gr.setAttribute("aria-disabled", "true"); self.restoreGift(Number(gr.getAttribute("data-gift-restore"))); } return; }
          var ad = e.target.closest("[data-addon]");
          if (ad) { self.addAddon(ad.getAttribute("data-addon"), ad); return; }
          var co = e.target.closest("[data-checkout]");
          if (co && KK.preview) { e.preventDefault(); toast("This opens Shopify checkout on the live store."); }
        });
        d.addEventListener("change", function (e) {
          if (e.target.matches("[data-protect]")) self.toggleProtection(e.target.checked);
        });
      }
      var scrim = $("[data-scrim]");
      if (scrim) scrim.addEventListener("click", function () { Overlay.closeCurrent(); });

      /* quick add forms (home packs, final call) */
      document.addEventListener("submit", function (e) {
        var f = e.target.closest && e.target.closest("form[data-quick-add]");
        if (!f) return;
        e.preventDefault();
        var props = {};
        if (Fighter.value) props.Fighter = Fighter.value;
        self.addVariant(new FormData(f).get("id"), props, $("button[type=submit]", f));
      });
      $$("[data-gift-remove-link]").forEach(function (a) {
        a.addEventListener("click", function () { self.decline(Number(a.getAttribute("data-gift-remove-link"))); });
      });
      // cart page: the − / + stepper updates the cart straight away (the Update button stays for no-JS)
      $$("[data-cart-page]").forEach(function (form) {
        var update = $("[data-cart-update]", form);
        var submit = function () {
          form.classList.add("is-busy");
          if (update && form.requestSubmit) form.requestSubmit(update);
          else if (update) update.click();
          else form.submit();
        };
        if (update) update.hidden = true;
        $$("[data-cart-step]", form).forEach(function (b) {
          b.addEventListener("click", function () {
            var input = document.getElementById(b.getAttribute("aria-controls"));
            if (!input) return;
            input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.getAttribute("data-cart-step")));
            submit();
          });
        });
        $$(".kk-qty__input", form).forEach(function (input) { input.addEventListener("change", submit); });
      });
      this.run(function () {
        return self.reconcileGift().then(function (changed) {
          if (changed && document.body.classList.contains("kk-t-cart")) { window.location.reload(); return; }
          return self.refresh();
        });
      }).catch(function () {});
    }
  };
  function bump() {
    $$("[data-cart-count]").forEach(function (el) {
      el.classList.remove("is-bump");
      void el.offsetWidth;
      el.classList.add("is-bump");
    });
  }

  /* ---------- product page: pack picker, add to cart, sticky bar ---------- */
  function updateGifts(root, units, packName) {
    var box = $("[data-gifts]", root);
    if (!box) return;
    var items = $$("[data-gift-units]", box);
    var unlocked = 0, nextNeed = null;
    items.forEach(function (it) {
      var need = Number(it.getAttribute("data-gift-units")) || 1;
      var on = units >= need;
      it.classList.toggle("is-locked", !on);
      if (on) unlocked++;
      else if (nextNeed === null || need < nextNeed) nextNeed = need;
    });
    var head = $("[data-gifts-head]", box);
    if (head) head.innerHTML = unlocked
      ? unlocked + " free gift" + (unlocked > 1 ? "s" : "") + " with your " + esc(packName)
      : "Free gift with " + nextNeed + " or more Roos";
  }
  function initProduct() {
    $$("[data-product]").forEach(function (root) {
      var form = $("form[data-product-form]", root);
      if (!form) return;
      var radios = $$("[data-pack]", root);
      var priceEl = $("[data-price]", root), perEl = $("[data-per]", root), saveEl = $("[data-save]", root), wasBar = $("[data-wasbar]", root);
      var sticky = $("[data-sticky]", root);
      function selected() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
      function update(push) {
        var r = selected();
        if (!r) return;
        radios.forEach(function (x) { var l = x.closest("[data-opt]"); if (l) l.classList.toggle("is-checked", x.checked); });
        var price = Number(r.getAttribute("data-price")), compare = Number(r.getAttribute("data-compare"));
        var units = Number(r.getAttribute("data-units")) || 1;
        var saving = compare > price;
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = units + (units > 1 ? " Roos · " + money(Math.round(price / units)) + " each" : " Roo");
        var was = Number(r.getAttribute("data-was")) || 0;
        if (wasBar) { wasBar.hidden = !(was > price); wasBar.textContent = money(was); }
        if (saveEl) { saveEl.hidden = !saving; saveEl.textContent = (was > price ? Math.round((was - price) / was * 100) + "% off · " : "") + "Save " + money(compare - price); }
        $$("[data-atc-price]", root).forEach(function (el) { el.textContent = money(price); });
        var idInput = $("[data-variant-input]", form);
        if (idInput) idInput.value = r.value;
        var soldOut = r.disabled;
        $$("[data-atc], [data-sticky-add]", root).forEach(function (b) { b.disabled = soldOut; });
        $$("[data-atc-label]", root).forEach(function (el) { el.textContent = soldOut ? "Sold out" : el.getAttribute("data-label"); });
        updateGifts(root, Number(r.getAttribute("data-units")) || 1, r.getAttribute("data-name"));
        var stickySel = $("[data-sticky-pack]", root);
        if (stickySel && stickySel.value !== r.value) stickySel.value = r.value;
        var sn = $("[data-sticky-name]", root), sp = $("[data-sticky-price]", root);
        if (sn) sn.textContent = r.getAttribute("data-name");
        if (sp) sp.textContent = money(price) + (saving ? " · Save " + money(compare - price) : " · Free shipping");
        if (push && !KK.preview && window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", r.value);
          window.history.replaceState({}, "", u.toString());
        }
      }
      radios.forEach(function (r) { r.addEventListener("change", function () { update(true); }); });
      var packSelect = $("[data-sticky-pack]", root);
      if (packSelect) packSelect.addEventListener("change", function () {
        var r = radios.filter(function (x) { return x.value === packSelect.value; })[0];
        if (r && !r.disabled) { r.checked = true; update(true); }
      });
      update(false);

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        Cart.addFromForm(form, $("[data-atc]", form));
      });
      $$("[data-sticky-add]", root).forEach(function (b) {
        b.addEventListener("click", function () { Cart.addFromForm(form, b); });
      });

      var atc = $("[data-atc]", form);
      var priceBar = $("[data-price]", root), pick = $(".kk-pick", root);
      var inView = function (el) { if (!el) return false; var b = el.getBoundingClientRect(); return b.top < window.innerHeight && b.bottom > 0; };
      if (sticky && atc) {
        var check = function () {
          var gone = priceBar ? priceBar.getBoundingClientRect().bottom < 0 : atc.getBoundingClientRect().bottom < 0;
          var on = gone && !inView(pick) && !inView(atc) && !Cart.isOpen();
          sticky.classList.toggle("is-on", on);
          sticky.setAttribute("aria-hidden", on ? "false" : "true");
          $$("button, select", sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        };
        window.addEventListener("scroll", check, { passive: true });
        window.addEventListener("resize", check);
        Cart.onToggle = check;
        check();
      }
    });
  }

  /* ---------- email popup ---------- */
  var Popup = {
    el: null,
    shown: false,
    init: function () {
      var p = $("[data-popup]");
      if (!p || !KK.popup || !KK.popup.on) return;
      this.el = p;
      var self = this;
      $$("[data-popup-close]", p).forEach(function (b) { b.addEventListener("click", function () { self.hide(); }); });
      p.addEventListener("click", function (e) { if (e.target === p) self.hide(); });
      var form = $("form", p);
      if (form) form.addEventListener("submit", function (e) { self.submit(e, form); });
      var copy = $("[data-copy-code]", p);
      if (copy) copy.addEventListener("click", function () { copyText(KK.popup.code); });

      var params = new URLSearchParams(window.location.search);
      if (params.get("customer_posted") === "true" && window.location.hash.indexOf("kk-popup") > -1) { this.show(true); return; }
      if (window.location.hash.indexOf("kk-popup") > -1 && $("[data-popup-server-err]", p)) { this.show(false, true); return; }
      if (store.get("kk-popup-done") || store.get("kk-popup-seen", true)) return;
      // never over the pack picker or the buy button, never once something is in the cart
      var inView = function (el) { var b = el.getBoundingClientRect(); return b.top < window.innerHeight && b.bottom > 0; };
      var calm = function () {
        if (Cart.state && Cart.state.item_count > 0) return false;
        return !$$(".kk-pick, [data-atc], .kk-packs, [data-drawer].is-on").some(inView);
      };
      var tryShow = function () { if (calm()) self.show(); };
      var start = Date.now(), wait = KK.popup.delay || 25000;
      this.timer = setInterval(function () { if (Date.now() - start > wait) tryShow(); if (self.shown) clearInterval(self.timer); }, 2000);
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.45 && Date.now() - start > 8000) tryShow();
        if (self.shown) window.removeEventListener("scroll", onScroll);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      var armedAt = Date.now() + 8000;
      document.addEventListener("mouseout", function (e) {
        if (!e.relatedTarget && e.clientY < 8 && Date.now() > armedAt && !(Cart.state && Cart.state.item_count > 0)) self.show();
      });
    },
    show: function (success, force) {
      if (this.shown) return;
      if (!success && !force && (Cart.isOpen() || Overlay.current)) return;
      this.shown = true;
      clearTimeout(this.timer);
      store.set("kk-popup-seen", "1", true);
      var p = this.el;
      this.lastFocus = document.activeElement;
      setBackgroundInert(true);
      p.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add("is-on"); }); });
      if (success) this.success();
      else setTimeout(function () { var f = $("input[type=email]", p); if (f) f.focus(); }, 120);
    },
    hide: function () {
      var p = this.el;
      if (!p) return;
      p.classList.remove("is-on");
      setTimeout(function () { p.hidden = true; }, 350);
      store.set("kk-popup-seen", "1", true);
      if (!Overlay.current) setBackgroundInert(false);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    success: function () {
      store.set("kk-popup-done", "1");
      var f = $("[data-popup-form]", this.el), d = $("[data-popup-done]", this.el);
      if (f) f.hidden = true;
      if (d) d.hidden = false;
    },
    submit: function (e, form) {
      e.preventDefault();
      var email = $("input[type=email]", form), err = $("[data-popup-err]", form);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
        err.textContent = "Enter an email like name@example.com";
        err.hidden = false;
        email.focus();
        return;
      }
      err.hidden = true;
      if (KK.preview) { this.success(); return; }
      var btn = $("button[type=submit]", form), self = this;
      btn.classList.add("is-loading");
      fetch(form.action, { method: "POST", body: new FormData(form), headers: { Accept: "text/html" } })
        .then(function (r) {
          if (!r.ok || r.url.indexOf("customer_posted=true") === -1) throw new Error("fallback");
          self.success();
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.classList.remove("is-loading"); });
    }
  };

  function initFooterNews() {
    if (window.location.hash !== "#kk-footer-news") return;
    $$("[data-footer-note]").forEach(function (el) { el.hidden = false; });
  }

  /* ---------- keyboard ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (Popup.el && !Popup.el.hidden) { Popup.hide(); return; }
    Overlay.closeCurrent();
  });

  /* ---------- reviews: "show all" + star badge under the product title ---------- */
  function initReviews() {
    $$("[data-reviews-more]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var root = btn.closest("[data-review-summary]") || document;
        $$("[data-review-more]", root).forEach(function (el) { el.hidden = false; });
        btn.hidden = true;
      });
    });
    var summary = $("[data-review-summary]"), badge = $("[data-rating-badge]");
    if (summary && badge && badge.hidden) {
      var r = Number(summary.getAttribute("data-rating")), n = Number(summary.getAttribute("data-count"));
      if (n > 0) {
        var st = $("[data-rating-stars]", badge);
        if (st) { st.style.setProperty("--rating", r); st.setAttribute("aria-label", r.toFixed(1) + " out of 5 stars"); }
        $("[data-rating-value]", badge).textContent = r.toFixed(1);
        $("[data-rating-count]", badge).textContent = n;
        badge.hidden = false;
      }
    }
  }

  /* ---------- start ---------- */
  function start() {
    Fighter.init();
    initAnnounce();
    initHeader();
    initEta();
    initCountdowns();
    initSpots();
    initReels();
    initVersus();
    initTabs();
    initReviews();
    initFooterNews();
    initVideos();
    initGallery();
    initProduct();
    Cart.init();
    Popup.init();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
